import { Link } from "react-router-dom";
import { Linkedin, Facebook, Youtube } from "lucide-react";
import { Logo } from "./Logo";
import { waLink } from "../lib/api";

const QUICK = [
  { label: "About Us", to: "/about" },
  { label: "Solutions", to: "/solutions" },
  { label: "Products", to: "/products" },
  { label: "Projects", to: "/projects" },
  { label: "Services", to: "/services" },
  { label: "Resources", to: "/resources" },
  { label: "Contact", to: "/contact" },
];

const SOLUTION_LINKS = [
  { label: "Hospital Setup", to: "/solutions#hospital-setup" },
  { label: "Medical Equipment", to: "/solutions#equipment" },
  { label: "Dialysis Solutions", to: "/solutions#dialysis" },
  { label: "OT & Critical Care", to: "/solutions#ot-critical-care" },
  { label: "Hospital Furniture", to: "/solutions#furniture" },
  { label: "Diagnostic Solutions", to: "/solutions#diagnostic" },
];

const SUPPORT_LINKS = [
  { label: "Request a Quote", to: "/contact?intent=quote" },
  { label: "Service Request", to: "/contact?intent=service" },
  { label: "Project Consultation", to: "/contact" },
];

const Footer = () => (
  <footer className="bg-brand-950 text-white" data-testid="site-footer">
    <div className="container-x grid grid-cols-1 gap-12 py-16 md:grid-cols-2 md:py-20 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
      <div>
        <Logo light />
        <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">
          Healthcare Solutions | Medical Equipment | Hospital Projects | After-Sales Support
        </p>
        <p className="mt-4 max-w-sm text-sm leading-relaxed text-white/60">
          From Medical Equipment to Complete Healthcare Solutions.
        </p>
        <div className="mt-6 space-y-1.5 text-sm text-white/60">
          <p data-testid="footer-contact-person" className="font-semibold text-white/80">Sagar Chakrabarti</p>
          <p data-testid="footer-address">Offices: New Delhi (Karol Bagh) · Siliguri · Kolaghat · Kharagpur</p>
          <p data-testid="footer-phone">
            <a href="tel:+919007337749" className="transition-colors hover:text-white">+91 90073 37749</a>
          </p>
          <p data-testid="footer-email">
            <a href="mailto:sagarc@accusurge.co.in" className="transition-colors hover:text-white">sagarc@accusurge.co.in</a>
          </p>
        </div>
        <div className="mt-6 flex items-center gap-3" data-testid="footer-social">
          <span className="sr-only">Social profiles to be updated</span>
          {[Linkedin, Facebook, Youtube].map((Icon, i) => (
            <span
              key={i}
              title="[To be updated]"
              className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/40"
            >
              <Icon className="h-4 w-4" />
            </span>
          ))}
          <a
            href={waLink()}
            target="_blank"
            rel="noreferrer"
            aria-label="WhatsApp AccuSurge"
            title="WhatsApp"
            className="flex h-9 w-9 items-center justify-center rounded-full border border-white/15 text-white/70 transition-colors hover:bg-accent hover:text-white"
          >
            <svg viewBox="0 0 24 24" className="h-4 w-4" fill="currentColor" aria-hidden="true">
              <path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Zm0 2a8 8 0 1 1-4.1 14.9l-.3-.2-2.9.8.8-2.8-.2-.3A8 8 0 0 1 12 4Zm-3 4c-.2 0-.5 0-.7.3-.2.3-.9.9-.9 2.1 0 1.2.9 2.4 1 2.6.1.2 1.7 2.8 4.3 3.8 2.1.8 2.6.7 3 .6.5 0 1.5-.6 1.7-1.2.2-.6.2-1.1.2-1.2-.1-.1-.3-.2-.6-.3l-2-.9c-.3-.1-.5-.1-.7.1l-.9 1.1c-.2.2-.3.2-.6.1a6.5 6.5 0 0 1-3.2-2.8c-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.4.3-.6.1-.2 0-.4 0-.6L9.7 8.4C9.6 8 9.4 8 9.2 8H9Z" />
            </svg>
          </a>
        </div>
      </div>
      {[
        { title: "Quick Links", links: QUICK },
        { title: "Solutions", links: SOLUTION_LINKS },
        { title: "Support", links: SUPPORT_LINKS },
      ].map((col) => (
        <nav key={col.title} aria-label={col.title}>
          <h3 className="font-mono text-[11px] font-medium uppercase tracking-[0.28em] text-accent">{col.title}</h3>
          <ul className="mt-6 space-y-3">
            {col.links.map((l) => (
              <li key={l.label}>
                <Link to={l.to} className="text-sm text-white/65 transition-colors hover:text-white" data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </div>
    <div className="border-t border-white/10">
      <div className="container-x flex flex-col items-start justify-between gap-3 py-6 pb-24 text-xs text-white/45 md:flex-row md:items-center md:pb-6">
        <p>© {new Date().getFullYear()} AccuSurge Medical Solutions Pvt. Ltd. All rights reserved.</p>
        <p>Committed to Care, Powered by Quality.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
